import React from 'react';

import Link from '@swf/components/Link/Link';
import Translation from '@swf/components/Translation/Translation';
import Plus18 from '@swf/core/assets/icons/18-logo-white-outlines.svg';
import DKLogo from '@swf/core/assets/icons/dk-logo.svg';
import { ResolverTag } from '@swf/core/enums';
import useResolver from '@swf/core/hooks/useResolver';

import {
  TXTCLI_Gamble_with_care,
  TXTWCL_HelplineX_StopSpilletXdk,
  TXTWCL_Self_exclude_at_N0
} from './DKHeaderContent.messages.json';
import styles from './DKHeaderContent.scss';

const DKHeaderContent: React.FC = () => {
  const responsibleGamingUrl = useResolver(ResolverTag.HelpResponsibleGaming);
  const regulatorUrl = useResolver(ResolverTag.DKRegulatorLogo);

  return (
    <div className={styles.linksContainer}>
      <Link href={responsibleGamingUrl} className={styles.link} isCrossPlatform openLinkInNewTab>
        <Translation {...TXTCLI_Gamble_with_care} />
      </Link>

      <Link
        href="https://www.stopspillet.dk/"
        className={styles.link}
        isCrossPlatform
        openLinkInNewTab
      >
        <Translation {...TXTWCL_HelplineX_StopSpilletXdk} />
      </Link>

      <Link href="https://www.rofus.nu/" className={styles.link} isCrossPlatform openLinkInNewTab>
        <Translation {...TXTWCL_Self_exclude_at_N0} values={{ 0: 'ROFUS.nu' }} />
      </Link>

      <div className={styles.iconsContainer}>
        <Link href={responsibleGamingUrl} isCrossPlatform openLinkInNewTab>
          <Plus18 className={styles.plus18} />
        </Link>

        <Link href={regulatorUrl} isCrossPlatform openLinkInNewTab>
          <DKLogo className={styles.dkLogo} />
        </Link>
      </div>
    </div>
  );
};

export default DKHeaderContent;
